module.exports = __webpack_public_path__ + "img/merit-logo.2b0fe683.svg";